/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserAccountCreateDto { 
    schoolId: number;
    firstName: string;
    lastName: string;
    email: string;
    /**
     * South African ID number of the person behind the account. An existing person with this ID is reused, so a teacher who already works at another school keeps one identity.
     */
    idNumber: string;
    /**
     * Minimum 8 characters, with uppercase, lowercase, number, and special character.
     */
    password: string;
    phone?: string;
    /**
     * Roles granted together with the account. Without one, the account can sign in but has no role-based access.
     */
    roles?: Array<UserAccountCreateDto.RolesEnum>;
}
export namespace UserAccountCreateDto {
    export const RolesEnum = {
        Teacher: 'Teacher',
        Staff: 'Staff'
    } as const;
    export type RolesEnum = typeof RolesEnum[keyof typeof RolesEnum];
}


